export const setDateFormat = (enableTime?: boolean, noCalendar?: boolean): string => {
    if (enableTime && noCalendar || noCalendar) {
        // time only
        return 'G:i K';
    } else if (enableTime) {
        // date and time
        return 'M d, Y, G:i K';
    }
    // date only
    return 'd-M-Y';
};
